/**
 * The row every advisor turn renders inside. No avatar icon — the panel is narrow enough that
 * the icon + gap cost real width without adding information (every row is already the advisor;
 * only the right-aligned UserMessage bubble needs to read as "the other speaker").
 */
export function AdvisorRow({ children }: { children: React.ReactNode }) {
  return <div className="animate-fade-in-up">{children}</div>;
}

/** The right-aligned bubble for what the user said. */
export function UserMessage({ text }: { text: string }) {
  return (
    <div className="flex animate-fade-in-up justify-end">
      <div
        className="rounded-2xl rounded-br-sm bg-revampBlue px-4 py-2.5 text-sm text-white"
        style={{ maxWidth: "85%" }}
      >
        {text}
      </div>
    </div>
  );
}
